import { render, staticRenderFns } from "./GameLauncherSingleGame.vue?vue&type=template&id=3fc8f72f&scoped=true&"
import script from "./GameLauncherSingleGame.vue?vue&type=script&lang=js&"
export * from "./GameLauncherSingleGame.vue?vue&type=script&lang=js&"
import style0 from "./GameLauncherSingleGame.vue?vue&type=style&index=0&id=3fc8f72f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc8f72f",
  null
  
)

export default component.exports